import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'


import DealerPage from '../modules/apps/master/dealer-management/DealerPage'




import RolePermissionPage from '../modules/apps/setting/role-permission-management/RolePermissionPage'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  //master management
  const WarehousesPage = lazy(() => import('../modules/apps/master/warehouse-management/WarehousePage'))
  const BeatPage = lazy(() => import('../modules/apps/master/beat-management/BeatPage'))
  const OutletPage = lazy(() => import('../modules/apps/master/outlet-management/OutletPage'))
  const ZonePage = lazy(() => import('../modules/apps/master/zone-management/ZonePage'))
  //State city district
  const StatePage = lazy(() => import('../modules/apps/master/state-management/StatePage'))
  const CityPage = lazy(() => import('../modules/apps/master/city-management/CityPage'))
  const DistrictPage = lazy(() => import('../modules/apps/master/district-management/DistrictPage'))
  const AreaPage = lazy(() => import('../modules/apps/master/area-management/AreaPage'))

  const DesignationPage = lazy(() => import('../modules/apps/master/designation-management/DesignationPage'))
  const RolePage = lazy(() => import('../modules/apps/master/role-management/RolePage'))
  const DivisionPage = lazy(() => import('../modules/apps/master/division-management/DivisionPage'))
  const OutletCategoryPage = lazy(() => import('../modules/apps/master/outletCategory-management/OutletCategoryPage'))
  const SchemePage = lazy(() => import('../modules/apps/master/scheme-management/SchemePage'))
  const OutletCustomerPage = lazy(() => import('../modules/apps/master/outletCustomer-management/OutletCustomerPage'))
  const DepartmentPage = lazy(() => import('../modules/apps/master/department-management/DepartmentPage'))
  const ExpensePage = lazy(() => import('../modules/apps/master/expense-management/ExpensePage'))



  //beat mapping
  const BeatBeatListMappingPage = lazy(() => import('../modules/apps/mapping/beat/beat-management/BeatPage'))
  const BeatOutletListMappingPage = lazy(() => import('../modules/apps/mapping/beat/outlet-management/OutletPage'))
  const UserListMappingPage = lazy(() => import('../modules/apps/mapping/user/user-management/UserPage'))
  const UserBeatListMappingPage = lazy(() => import('../modules/apps/mapping/user/beat-management/BeatPage'))
  const MtpListMappingPage = lazy(() => import('../modules/apps/mapping/mtp/mtp-management/MtpPage'))

  //user management
  const AttendancePage = lazy(() => import('../modules/apps/user/attendance-management/AttendancePage'))
  const UserPage = lazy(() => import('../modules/apps/user/user-management/UserPage'))
  const LeavePage = lazy(() => import('../modules/apps/user/leave-management/LeavePage'))

  //order management
  const OrderPage = lazy(() => import('../modules/apps/order/order-management/OrderPage'))
  const ReturnOrderPage = lazy(() => import('../modules/apps/order/return-order-management/ReturnOrderPage'))
  //ItemPage
  const ItemPage = lazy(() => import('../modules/apps/item/item-management/ItemPage'))


  //report
  const ReportAttendancePage = lazy(() => import('../modules/apps/report/attendance/AttendancePage'))
  const ReportDaySummaryPage = lazy(() => import('../modules/apps/report/daySummary/DaySummaryPage'))
  const ReportPerformanceSummaryPage = lazy(() => import('../modules/apps/report/performanceSummary/PerformanceSummaryPage'))
  const ActivitySummaryPage = lazy(() => import('../modules/apps/report/activitySummary/ActivitySummaryPage'))
  const SkuOrderDetailsPage = lazy(() => import('../modules/apps/report/skuOrderDetails/SkuOrderDetailsPage'))
  const ReportExpensePage = lazy(() => import('../modules/apps/report/expense/ExpensePage'))
  const OrderLocationsPage = lazy(() => import('../modules/apps/report/orderLocation/OrderLocationsPage'))

  //Expense Entry
  const ExpenseEntryPage = lazy(() => import('../modules/apps/expense/expense-entry/ExpenseEntryPage'))



  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/order/order-management/*'
          element={
            <SuspensedView>
              <OrderPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/order/return-order-management/*'
          element={
            <SuspensedView>
              <ReturnOrderPage />
            </SuspensedView>
          }
        />


        <Route
          path='apps/user/user-management/*'
          element={
            <SuspensedView>
              <UserPage />
            </SuspensedView>
          }
        />
       
        <Route
          path='apps/user/leave-management/*'
          element={
            <SuspensedView>
              <LeavePage />
            </SuspensedView>
          }
        />



        <Route
          path='apps/master/warehouse-management/*'
          element={
            <SuspensedView>
              <WarehousesPage />
            </SuspensedView>
          }
        />


        <Route
          path='apps/master/dealer-management/*'
          element={
            <SuspensedView>
              <DealerPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/master/zone-management/*'
          element={
            <SuspensedView>
              <ZonePage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/master/beat-management/*'
          element={
            <SuspensedView>
              <BeatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/master/outlet-management/*'
          element={
            <SuspensedView>
              <OutletPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/master/state-management/*'
          element={
            <SuspensedView>
              <StatePage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/master/city-management/*'
          element={
            <SuspensedView>
              <CityPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/master/district-management/*'
          element={
            <SuspensedView>
              <DistrictPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/master/area-management/*'
          element={
            <SuspensedView>
              <AreaPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/master/designation-management/*'
          element={
            <SuspensedView>
              <DesignationPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/master/role-management/*'
          element={
            <SuspensedView>
              <RolePage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/master/division-management/*'
          element={
            <SuspensedView>
              <DivisionPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/master/outletCategory-management/*'
          element={
            <SuspensedView>
              <OutletCategoryPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/master/division-management/*'
          element={
            <SuspensedView>
              <DivisionPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/master/scheme-management/*'
          element={
            <SuspensedView>
              <SchemePage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/master/outletCustomer-management/*'
          element={
            <SuspensedView>
              <OutletCustomerPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/master/department-management/*'
          element={
            <SuspensedView>
              <DepartmentPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/master/expense-management/*'
          element={
            <SuspensedView>
              <ExpensePage />
            </SuspensedView>
          }
        />

        {/* reports */}
        <Route
          path='apps/report/attendance/*'
          element={
            <SuspensedView>
              <ReportAttendancePage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/report/user-attendance/*'
          element={
            <SuspensedView>
              <AttendancePage />
            </SuspensedView>
          }
        />

        {/* Expence Entry */}
        <Route
          path='apps/expense/expense-entry/*'
          element={
            <SuspensedView>
              <ExpenseEntryPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/report/daySummary/*'
          element={
            <SuspensedView>
              <ReportDaySummaryPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/report/performanceSummary/*'
          element={
            <SuspensedView>
              <ReportPerformanceSummaryPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/report/activitySummary/*'
          element={
            <SuspensedView>
              <ActivitySummaryPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/report/skuOrderDetails/*'
          element={
            <SuspensedView>
              <SkuOrderDetailsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/report/expense/*'
          element={
            <SuspensedView>
              <ReportExpensePage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/report/orderLocation/*'
          element={
            <SuspensedView>
              <OrderLocationsPage />
            </SuspensedView>
          }
        />


        {/* MappingPage*/}
        <Route
          path='apps/mapping/beat/beat-management/*'
          element={
            <SuspensedView>
              <BeatBeatListMappingPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/mapping/beat/outlet-management/*'
          element={
            <SuspensedView>
              <BeatOutletListMappingPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/mapping/user/user-management/*'
          element={
            <SuspensedView>
              <UserListMappingPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/mapping/user/beat-management/*'
          element={
            <SuspensedView>
              <UserBeatListMappingPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/mapping/mtp/mtp-management/*'
          element={
            <SuspensedView>
              <MtpListMappingPage />
            </SuspensedView>
          }
        />




        {/* Setting */}

        <Route
          path='apps/setting/role-permission-management/*'
          element={
            <SuspensedView>
              <RolePermissionPage />
            </SuspensedView>
          }
        />
        {/* Item */}
        <Route
          path='apps/item/item-management/*'
          element={
            <SuspensedView>
              <ItemPage />
            </SuspensedView>
          }
        />



        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
